import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom'
import { createContact } from 'Api'
import ContactLayout from './index';
import { CircularProgress } from '@material-ui/core'
import { checkTimeout } from 'Api/ApiCall'

export default () => {

    const history = useHistory();
    const [ loading, setLoading ] = useState(true);

    const loadData = async () => {
        checkTimeout()
        setLoading(false);
    }

    useEffect(() => {
        loadData();
    })

    let content = null;
    if (loading) {
        content = <CircularProgress />
    } else {
        content = (
            <ContactLayout
                layout="create"
                saveData={async data => {

                    const result = await createContact({ data });
                    return result;
                }}
                onSaved={contact => {
                    history.push("/contact/" + contact.objectId);
                }}
            />
        )
    }
    
    return (
        <>
           {content}
       </>
   )
}